import commonNav from '@/components/common-nav/index.vue';

import {
	createNamespacedHelpers
} from 'vuex';
const sroreName = {
	result: 'qrCode',
};
const {
	mapActions
} = createNamespacedHelpers(sroreName.result);
export default {
	data() {
		return {
      credit: '200.00',
			money: '',
      balance: '100.23',
			time: '2024-05-27 12:32',
			rechargeId: '',
			qrCode:'http://eccschool.com/uploads/qrcode/e3bec6df909ab409660b32360d786071.png',
		};
	},
	components: {
		'common-nav': commonNav,
	},
	mounted() {
		this.updateImg();
	},
	watch: {
		
	},
	methods: {
		...mapActions({
			getQrCode: 'getQrCode'
		}),
		async loadData(){
			if(location.search){
				let getParam = decodeURIComponent(location.search).substring(1);
				getParam = getParam.split('?')[0];
				getParam = getParam.split('&');
				getParam.forEach((item)=>{
					item = item.split('=');
					this[item[0]] = item[1];
				});

			}
		},
    async updateImg(){
      const resultData = await this.getQrCode({
        content: this,
        data: {
          id: this.rechargeId
        }
      });
      var qrCodeInfo = resultData.data;
      this.credit = qrCodeInfo.credit;
      this.balance = (qrCodeInfo.balance/100.00).toFixed(2);
      this.qrCode = qrCodeInfo.qrCode;
      this.time = qrCodeInfo.time;
		}
	}
};
